<script setup>
import { usePlatformConfigurationStore } from '@/stores/platform_configuration';

const platformConfigurationStore = usePlatformConfigurationStore();

const is_chat_enabled = process.env.VUE_APP_CHAT_ENABLED == 'true';
const show_whatsapp_on_header = platformConfigurationStore.showWhatsappOnHeader;

const openChat = () => {
	const y = window.scrollY || window.pageYOffset || 0;
	document.activeElement?.blur?.();

	platformConfigurationStore.openLiveChat();

	// Tawk.to locks the body on maximize — clean up after the toggle
	if (window.Tawk_API) {
		requestAnimationFrame(() => {
			const body = document.body;
			const html = document.documentElement;
			['position', 'top', 'left', 'right', 'width', 'height', 'min-height', 'max-height', 'max-width', 'overflow']
				.forEach(prop => body.style.removeProperty(prop));
			html.style.removeProperty('overflow');
			if (location.hash === '#max-widget') {
				history.replaceState(null, document.title, location.pathname + location.search);
			}
			window.scrollTo(0, y);
		});
	}
};

const openWhatsapp = () => {
	window.open(show_whatsapp_on_header, '_blank');
};

</script>

<template>
	<img style="cursor:pointer;" v-if="usePlatformConfigurationStore().isLiveChatHeader && is_chat_enabled" @click.prevent="openChat" src="/assets/images/livechat_icon.svg"  width="30" height="30"  viewBox="0 0 25.207 25.207"/>

	<img style="cursor:pointer;" v-if="show_whatsapp_on_header" @click.prevent="openWhatsapp" src="/assets/images/wa_icon.svg"  width="25" height="25"  viewBox="0 0 25.207 25.207"/>
</template>